import { observer } from 'mobx-react';
import { currentUserStore } from '../../../../CurrentUserStore';
import { useFetch, useFindLinkByR } from '../../../../Fetch';
import { organizationResourceDecoder } from '../../../../Organization/Decoder';
import ParticipantsStore from '../../../../ParticipantsStore';
import { ParticipantsOptionsResource } from '../../../../ParticipantsStore/Options/Types';
import GeneralFilters from '../GeneralFilters';
import Filters from './Filters';
import ParticipantsState from './ParticipantsState';

interface Props {
  participantsStore: ParticipantsStore;
  participantsOptionsResource: ParticipantsOptionsResource;
}

function BodyReady({ participantsStore, participantsOptionsResource }: Props) {
  const organizationLink = useFindLinkByR({ rel: 'organization' }, currentUserStore.links);
  const state = useFetch(organizationLink, organizationResourceDecoder);

  switch (state.kind) {
    case 'loading':
    case 'errored':
      return (
        <div className="flex flex-col py-5 md:flex-row ">
          <GeneralFilters
            participantsOptionsResource={participantsOptionsResource}
            participantsStore={participantsStore}
            selectedOrganization={participantsStore.selectedOrganization}
          />
        </div>
      );
    case 'ready': {
      const { licenseFamily } = state.data.payload;
      return (
        <>
          <Filters
            participantsStore={participantsStore}
            licenseFamily={licenseFamily}
            participantsOptionsResource={participantsOptionsResource}
          />
          <ParticipantsState participantsStore={participantsStore} licenseFamily={licenseFamily} />
        </>
      );
    }
  }
}

export default observer(BodyReady);
